<template>
  <div class="b-capsule-content">
    <b-row
      class="justify-content-center"
      v-for="(row, index) in rows"
      :key="index"
    >
      <b-col
        cols="4"
        sm="4"
        md="3"
        lg="3"
        class="layer"
        v-for="layer in row"
        :key="layer.id"
      >
        <CapsuleLayer :layer="layer" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CapsuleLayer from "@/components/capsule/CapsuleLayer";
import CapsuleUtils from "@/utils/CapsuleUtils";

export default {
  components: {
    CapsuleLayer,
  },

  created() {
    this.sortLayersByGroups = CapsuleUtils.sortLayersByGroups;
    this.topRow = this.sortGroups(["top", "bottom"]);
    this.bottomRow = this.sortGroups(["footwear", "accessory"]);

    if (this.topRow.length === 4 && this.bottomRow.length <= 2) {
      this.topRow = this.sortGroups(["top"]);
      this.bottomRow = this.sortGroups(["bottom", "footwear", "accessory"]);

      this.rows = [this.topRow, this.bottomRow];
    } else if (this.topRow.length === 4) {
      this.rows = [this.topRow.concat(this.bottomRow)];
    } else {
      this.rows = [this.topRow, this.bottomRow];
    }
  },

  data() {
    return {
      topRow: null,
      bottomRow: null,
      rows: null,
    };
  },

  props: {
    capsule: {
      type: Object,
      required: true,
    },

    stitchMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    sortGroups(groups) {
      return this.sortLayersByGroups(this.capsule.layers, groups);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_breakpoints.scss";

.layer {
  padding: 0.25rem;
}
@include for-tablet-landscape-up {
  .layer {
    padding: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsule/CapsuleContent.vue